<template>
  <b-card style="position: relative">

    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12">
          <container-form :request-data="requestData" :errors="errors"></container-form>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
            {{ $t('Save') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>

  </b-card>
</template>

<script>

import ContainerForm from '@/views/modules/containers/ContainerForm'
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import RfidForm from '@/views/modules/rfid/components/Form'
import containerStoreModule from '@/app/containers/containerStoreModule'
import { BButton, BCard, BCol, BForm, BFormGroup, BFormInput,
  BInputGroup, BRow, BAlert, BTabs, BTab, BCardText, BTable, BPagination
} from 'bootstrap-vue'


export default {

  name: 'CreateContainer',
  directives: { Ripple, },
  components: { RfidForm, BRow, BCard, BCol, BAlert, BTable,BPagination,ContainerForm,
    BFormGroup, BFormInput, BInputGroup, BForm, BButton, BTabs, BCardText, BTab, vSelect, OrbitSpinner
  },

  setup(props, {root}) {

    const CONTAINER_STORE = 'container'
    store.registerModule(CONTAINER_STORE, containerStoreModule)

    onUnmounted(() => {
      if (store.hasModule(CONTAINER_STORE))
        store.unregisterModule(CONTAINER_STORE)
    })


    const loading = ref(false)
    const errors = ref({})

    const formData = {
      name: null,
      tag: null,
      code: null,
      type_id: null,
      owner_id: null,
      contract_id: null,
    }


    const requestData = ref(Object.assign({}, formData))

    const save = () => {

      loading.value = true
      store.dispatch(`${CONTAINER_STORE}/createContainer`, requestData.value).then(res => {
        errors.value = {}
        Object.assign(requestData.value, formData)
        root.$bvToast.toast(
            root.$i18n.t("container created successfully"), { title: `Success`, variant: 'success', })
      }).catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
          root.$bvToast.toast(
              root.$i18n.t(e.response.data.message), { title: `Error`, variant: 'danger', })
        }
      }).finally(() => loading.value = false)
    }

    return {
      loading,
      requestData,
      errors,
      save
    }

  }
}
</script>

<style scoped>

</style>
